import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

type StyleProps = {
  marginTop?: number;
};

const useStyles = makeStyles<Theme, StyleProps>(() => ({
  padder: {
    paddingLeft: 24,
    paddingRight: 24,
    marginTop: (props) => props.marginTop ?? 0,
  },
}));

const GridDivider = ({ marginTop = 0 }) => {
  const classes = useStyles({ marginTop });

  return (
    <Grid item xs={12} className={classes.padder}>
      <Divider />
    </Grid>
  );
};

export default GridDivider;
